"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.init = exports.payments = void 0;
const toccata_1 = require("@musicaudienceexchange/toccata");
const app_1 = require("../app");
// eslint-disable-next-line @typescript-eslint/no-namespace
var payments;
(function (payments) {
    payments.PaymentItemTypes = ['shoutout', 'meetgreet'];
    class Customer extends toccata_1.Model {
    }
    __decorate([
        toccata_1.validator.IsEmail()
    ], Customer.prototype, "email", void 0);
    __decorate([
        toccata_1.validator.IsString()
    ], Customer.prototype, "firstName", void 0);
    __decorate([
        toccata_1.validator.IsString()
    ], Customer.prototype, "lastName", void 0);
    payments.Customer = Customer;
    class PaymentItem extends toccata_1.Model {
        constructor() {
            super(...arguments);
            this.quantity = 1;
            this.description = '';
            this.metadata = {};
        }
    }
    __decorate([
        toccata_1.validator.IsString()
    ], PaymentItem.prototype, "id", void 0);
    __decorate([
        toccata_1.validator.IsString()
    ], PaymentItem.prototype, "label", void 0);
    __decorate([
        toccata_1.validator.IsString()
    ], PaymentItem.prototype, "type", void 0);
    __decorate([
        toccata_1.validator.IsNumber()
    ], PaymentItem.prototype, "amount", void 0);
    __decorate([
        toccata_1.validator.IsNumber()
    ], PaymentItem.prototype, "quantity", void 0);
    __decorate([
        toccata_1.validator.IsString()
    ], PaymentItem.prototype, "description", void 0);
    __decorate([
        toccata_1.validator.IsObject(),
        toccata_1.validator.IsOptional()
    ], PaymentItem.prototype, "metadata", void 0);
    __decorate([
        toccata_1.validator.IsString(),
        toccata_1.validator.IsOptional()
    ], PaymentItem.prototype, "conversionTracking", void 0);
    __decorate([
        toccata_1.validator.IsString(),
        toccata_1.validator.IsOptional()
    ], PaymentItem.prototype, "twitterTagId", void 0);
    payments.PaymentItem = PaymentItem;
    class InitPaymentRequest extends toccata_1.Model {
    }
    __decorate([
        (0, toccata_1.TransformValidateModel)(PaymentItem)
    ], InitPaymentRequest.prototype, "item", void 0);
    __decorate([
        (0, toccata_1.TransformValidateModel)(Customer)
    ], InitPaymentRequest.prototype, "customer", void 0);
    payments.InitPaymentRequest = InitPaymentRequest;
    class InitPaymentResponse extends toccata_1.Model {
        constructor() {
            super(...arguments);
            this.success = false;
        }
    }
    __decorate([
        toccata_1.validator.IsBoolean()
    ], InitPaymentResponse.prototype, "success", void 0);
    __decorate([
        toccata_1.validator.IsBoolean(),
        toccata_1.validator.IsOptional()
    ], InitPaymentResponse.prototype, "purchase_complete", void 0);
    __decorate([
        toccata_1.validator.IsBoolean(),
        toccata_1.validator.IsOptional()
    ], InitPaymentResponse.prototype, "has_payment_method", void 0);
    __decorate([
        toccata_1.validator.IsString(),
        toccata_1.validator.IsOptional()
    ], InitPaymentResponse.prototype, "token", void 0);
    __decorate([
        toccata_1.validator.IsString(),
        toccata_1.validator.IsOptional()
    ], InitPaymentResponse.prototype, "error", void 0);
    payments.InitPaymentResponse = InitPaymentResponse;
    class FinalizePaymentRequest extends toccata_1.Model {
    }
    __decorate([
        toccata_1.validator.IsString()
    ], FinalizePaymentRequest.prototype, "paymentIntentId", void 0);
    payments.FinalizePaymentRequest = FinalizePaymentRequest;
    class PaymentCard extends toccata_1.Model {
    }
    __decorate([
        toccata_1.validator.IsString()
    ], PaymentCard.prototype, "last4", void 0);
    __decorate([
        toccata_1.validator.IsString()
    ], PaymentCard.prototype, "brand", void 0);
    __decorate([
        toccata_1.validator.IsNumber()
    ], PaymentCard.prototype, "expMonth", void 0);
    __decorate([
        toccata_1.validator.IsNumber()
    ], PaymentCard.prototype, "expYear", void 0);
    __decorate([
        toccata_1.validator.IsString()
    ], PaymentCard.prototype, "country", void 0);
    payments.PaymentCard = PaymentCard;
    class PaymentDetails extends toccata_1.Model {
    }
    __decorate([
        toccata_1.validator.IsNumber()
    ], PaymentDetails.prototype, "amount", void 0);
    __decorate([
        (0, toccata_1.TransformValidateModel)(PaymentCard),
        toccata_1.validator.IsOptional()
    ], PaymentDetails.prototype, "card", void 0);
    payments.PaymentDetails = PaymentDetails;
    class FinalizePaymentResponse extends toccata_1.Model {
    }
    __decorate([
        toccata_1.validator.IsBoolean()
    ], FinalizePaymentResponse.prototype, "success", void 0);
    __decorate([
        (0, toccata_1.TransformValidateModel)(PaymentDetails),
        toccata_1.validator.ValidateIf((o) => o.success)
    ], FinalizePaymentResponse.prototype, "details", void 0);
    payments.FinalizePaymentResponse = FinalizePaymentResponse;
    class ConnectAccountRequest extends toccata_1.Model {
    }
    __decorate([
        toccata_1.validator.IsUrl({
            protocols: ['http', 'https'],
            allow_underscores: true,
            require_tld: false,
        })
    ], ConnectAccountRequest.prototype, "redirectUri", void 0);
    __decorate([
        toccata_1.validator.IsString()
    ], ConnectAccountRequest.prototype, "artistGroupId", void 0);
    payments.ConnectAccountRequest = ConnectAccountRequest;
    payments.AccountStatusTypes = ['active', 'inactive', 'pending'];
    class ConnectAccountResponse extends toccata_1.Model {
        constructor() {
            super(...arguments);
            this.accountId = '';
            this.status = 'inactive';
        }
    }
    __decorate([
        toccata_1.validator.IsString()
    ], ConnectAccountResponse.prototype, "accountId", void 0);
    __decorate([
        toccata_1.validator.IsString(),
        toccata_1.validator.IsIn(payments.AccountStatusTypes)
    ], ConnectAccountResponse.prototype, "status", void 0);
    __decorate([
        toccata_1.validator.IsUrl({
            protocols: ['http', 'https'],
            allow_underscores: true,
            require_tld: false,
        }),
        toccata_1.validator.IsOptional()
    ], ConnectAccountResponse.prototype, "url", void 0);
    payments.ConnectAccountResponse = ConnectAccountResponse;
})(payments = exports.payments || (exports.payments = {}));
function init(firebaseApp) {
    const functions = firebaseApp
        ? firebaseApp.functions()
        : app_1.app.firebase.functions();
    return {
        initPayment: (0, toccata_1.createFunction)(functions, 'shoutout-paymentInit', payments.InitPaymentRequest, payments.InitPaymentResponse),
        finalizePayment: (0, toccata_1.createFunction)(functions, 'shoutout-paymentFinalize', payments.FinalizePaymentRequest, payments.FinalizePaymentResponse),
        connectAccount: (0, toccata_1.createFunction)(functions, 'shoutout-connectAccount', payments.ConnectAccountRequest, payments.ConnectAccountResponse),
    };
}
exports.init = init;
//# sourceMappingURL=payments.js.map